import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { ObjectStoreEditForm } from "./components/ObjectStoreEditForm";

export function EditObjectStorePage() {
  return (
    <Page title="Edit Object Store">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <ObjectStoreEditForm />
      </Container>
    </Page>
  );
}
